import { Box } from '@mui/material'
import { mostrarFecha } from '../../../../utils/DateFunctions'

interface ConversacionFechaProps {
  hoy: string
  fecha: string
}

const ConversacionFecha = ({ hoy, fecha }: ConversacionFechaProps) => {
  return (
    <Box
      sx={{
        width: 'fit-content',
        justifySelf: 'center',
        padding: '5px 10px',
        margin: '5px 0px',
        borderRadius: '5px',
        backgroundColor: '#313131',
        color: '#aaa',
        fontSize: '12px'
      }}
    >
      {fecha === hoy ? 'Hoy' : fecha}
    </Box>
  )
}

export default ConversacionFecha
